import ActivitiesMyTask from "@pages/Activities/MyTask";
import ActivitiesPendingApprovalTask from "@pages/Activities/PendingApproval";
import ActivitiesApprovedTaskTask from "@pages/Activities/ApprovedTask";
// import ActivitySubTask from "@components/common/ActivityRepositoryDetail/SubTasks";
// import ActivityTaskDetails from "@components/common/ActivityRepositoryDetail/TaskDetails";
// import ActivityTaskHistory from "@components/common/ActivityRepositoryDetail/TaskHistory";
import ActivitiesMyTaskCalenderView from "@pages/Activities/MyTask/calender";
import SelfComplianceTaskDetailsPage from "@components/common/SelfComplianceDetail/TaskDetails";
import SelfComplianceTaskHistoryPage from "@components/common/SelfComplianceDetail/TaskHistory";
import MyTaskList from "@pages/MyTasks";

export const ActivityRoutes = [
  // activities
  //my task
  {
    path: "/activities/self-compliance/my-task",
    name: "activities_self_compliance_executor_task",
    component: ActivitiesMyTask,
  },
  {
    path: "/activities/self-compliance/my-task/calenderView",
    name: "activities_self_compliance_executor_task",
    component: ActivitiesMyTaskCalenderView,
  },
  {
    path: "/activities/self-compliance/my-task/task-details/:id/:checkpoint_id",
    name: "activities_self_compliance_executor_task",
    component: SelfComplianceTaskDetailsPage,
  },
  {
    path: "/activities/self-compliance/my-task/task-history/:id/:checkpoint_id",
    name: "activities_self_compliance_executor_task",
    component: SelfComplianceTaskHistoryPage,
  },
  // {
  // 	path: "/activities/self-compliance/my-task/sub-task/:id/:checkpoint_id",
  // 	name: "activities_my_tasks",
  // 	component: ActivitySubTask,
  // },

  //pending travel
  {
    path: "/activities/self-compliance/pending-approval",
    name: "activities_self_compliance_evaluator_approval",
    component: ActivitiesPendingApprovalTask,
  },
  {
    path: "/activities/self-compliance/pending-approval/task-details/:id/:checkpoint_id",
    name: "activities_self_compliance_evaluator_approval",
    component: SelfComplianceTaskDetailsPage,
  },
  {
    path: "/activities/self-compliance/pending-approval/task-history/:id/:checkpoint_id",
    name: "activities_self_compliance_evaluator_approval",
    component: SelfComplianceTaskHistoryPage,
  },
  // {
  // 	path: "/activities/self-compliance/pending-approval/sub-task/:id/:checkpoint_id",
  // 	name: "activities_self_compliance_evaluator_approval",
  // 	component: ActivitySubTask,
  // },

  //Approved Task
  {
    path: "/activities/self-compliance/approved-task",
    name: "activities_self_compliance_completed_task",
    component: ActivitiesApprovedTaskTask,
  },
  {
    path: "/activities/self-compliance/approved-task/task-details/:id/:checkpoint_id",
    name: "activities_self_compliance_completed_task",
    component: SelfComplianceTaskDetailsPage,
  },
  {
    path: "/activities/self-compliance/approved-task/task-history/:id/:checkpoint_id",
    name: "activities_self_compliance_completed_task",
    component: SelfComplianceTaskHistoryPage,
  },
  // {
  // 	path: "/activities/self-compliance/approved-task/sub-task/:id/:checkpoint_id",
  // 	name: "activities_self_compliance_completed_task",
  // 	component: ActivitySubTask,
  // },

  //------------------- My Tasks -----------------//
  {
    path: "/activities/self-compliance/my-task/my-tasks",
    name: "activities_self_compliance_completed_task",
    component: MyTaskList,
  },
  {
    path: "/activities/self-compliance/pending-approval/my-tasks",
    name: "activities_self_compliance_completed_task",
    component: MyTaskList,
  },
  {
    path: "/repository/mapped-checkpoint/function-head/my-tasks",
    name: "activities_self_compliance_completed_task",
    component: MyTaskList,
  },
  {
    path: "/repository/mapped-checkpoint/evaluator/my-tasks",
    name: "activities_self_compliance_completed_task",
    component: MyTaskList,
  },
];
